import script from "./RatingInput.vue?vue&type=script&setup=true&lang=js"
export * from "./RatingInput.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__